function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '/web_modules/react.js';
import styled from '/web_modules/styled-components.js';
import { motion, AnimateSharedLayout } from '/web_modules/framer-motion.js';
import { gap } from './Layout.js';
const Divider = styled.div.withConfig({
  displayName: "Navigation__Divider",
  componentId: "sc-1su50ry-0"
})(["height:100%;width:1px;background:#474747;"]);
const NavigationButtonUnderline = styled(motion.div).withConfig({
  displayName: "Navigation__NavigationButtonUnderline",
  componentId: "sc-1su50ry-1"
})(["width:100%;height:1px;background:#353535;"]);
const NavigationButtonWrap = styled(motion.button).withConfig({
  displayName: "Navigation__NavigationButtonWrap",
  componentId: "sc-1su50ry-2"
})(["font-size:14px;border:none;background:none;padding:0;font-family:'Overpass';&[data-state='initial']{color:#474747;}&[data-state='active']{color:#353535;font-weight:bold;}"]);
export const NavigationButton = ({
  children,
  isActive,
  ...props
}) => /*#__PURE__*/React.createElement(NavigationButtonWrap, _extends({}, props, {
  animate: true,
  "data-state": isActive ? 'active' : 'initial'
}), /*#__PURE__*/React.createElement("span", null, children), isActive && /*#__PURE__*/React.createElement(NavigationButtonUnderline, {
  layoutId: "navigationButtonUnderline"
}));
const NavigationWrap = styled.nav.withConfig({
  displayName: "Navigation__NavigationWrap",
  componentId: "sc-1su50ry-3"
})(["display:flex;", " height:32px;justify-content:flex-end;> div:first-of-type{flex-grow:0;display:flex;justify-content:flex-end;}> div:last-of-type{flex-grow:0;display:flex;justify-content:flex-start;}"], gap('16px', 'row'));

const NavigationComponent = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(AnimateSharedLayout, null, /*#__PURE__*/React.createElement(NavigationWrap, props, /*#__PURE__*/React.createElement("div", null, children[0]), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("div", null, children[1])));
};

export const Navigation = styled(NavigationComponent).withConfig({
  displayName: "Navigation",
  componentId: "sc-1su50ry-4"
})([""]);